import { ID } from 'shared/types/id';
import { HabitSortingMode } from 'shared/types/sorting-mode';
import { TaskPriorityOptions } from 'shared/types/task-base';

import { getUser, getUserRef } from './get-user';
import { updateDocWithTimestamp } from './helpers';

export const updateHabitPriorityTaskOrder = async (
  priorities: { priority: TaskPriorityOptions; taskIds: ID[] }[],
) => {
  const user = await getUser();
  // without a user we cannot update anything.
  if (!user) {
    return;
  }

  const userRef = await getUserRef();

  if (!userRef) {
    return;
  }

  const settingsToUpdate = priorities.reduce<
    Partial<
      Record<
        `settings.habitGroupSorting.priority.sorting.${TaskPriorityOptions}`,
        ID[]
      >
    > & { 'settings.habitSortingMode': HabitSortingMode }
  >(
    (acc, { priority, taskIds }) => {
      acc[`settings.habitGroupSorting.priority.sorting.${priority}`] = taskIds;
      return acc;
    },
    { 'settings.habitSortingMode': HabitSortingMode.Custom },
  );

  updateDocWithTimestamp(userRef, settingsToUpdate);
};
